import {
  Base,
  Component,
  Prop,
  ProvideReactive
} from '@/vue-property-decorator'
import { _FavoriteIconBase as FavoriteIconBase } from './cssVar/favoriteIconBase'
import { _FavoriteIconHeartDefault as FavoriteIconHeartDefault } from './cssVar/favoriteIconHeartDefault'
import { _FavoriteIconRectangleStar as FavoriteIconRectangleStar } from './cssVar/favoriteIconRectangleStar'
import { _FavoriteIconStarDefault as FavoriteIconStarDefault } from './cssVar/favoriteIconStarDefault'
import { GetCssVarManager } from '../../../components/baseCssVarProvide'
import CircleStar31 from './circlrStar-31'
import CirclrStar from './circlrStar'
import LoneStar from './loneStar'
import RectangleStar from './rectangleStar'
import TriangleHeart from './triangleHeart'
import style from './style.module.scss'
export type FavoriteIconCssVarManager = GetCssVarManager<FavoriteIconBase>
export {
  FavoriteIconBase,
  FavoriteIconHeartDefault,
  FavoriteIconRectangleStar,
  FavoriteIconStarDefault
}
// 11月13号标记
// 心型和其它的差距其实挺大的,之后还是得找时间将之抽离,并且当前心型的尺寸也是写死的.不太容易在其它地方复用

/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
type Props = {
  /** 图标是否禁用点击 */
  forbidClick?: boolean
  /** 收藏状态 */
  isFavorited?: boolean
}
type Events = {
  onClick: (event: Props['isFavorited']) => void
}
interface State {
  /** 图标是否展示动画 */
  animation: boolean
}
@Component<FavoriteIcon>({
  name: 'FavoriteIcon'
})
export default class FavoriteIcon extends Base<State, Props, Events> {
  /** 心型-默认样式 */
  public static getCssVarHeartDefault = () => new FavoriteIconHeartDefault()
  /** 方型-默认样式 */
  public static getCssVarRectangle = () => new FavoriteIconRectangleStar()

  /** 圆形背景+星型图案 */
  public static CircleStar = CirclrStar
  /** 圆形背景+星型图案-定制版通用 */
  public static CircleStar31 = CircleStar31
  /** 三角型+心型 */
  public static TriangleHeart = TriangleHeart
  /** 单个的星量图案 */
  public static LoneStar = LoneStar
  /** 正方型背景+星形图案 */
  public static RectangleStar = RectangleStar

  @Prop({ default: false })
  private forbidClick?: Required<Props>['forbidClick']
  @ProvideReactive()
  @Prop({ default: false })
  private isFavorited!: Required<Props>['isFavorited']

  render() {
    const { forbidClick } = this
    return (
      <div
        role={'FavoriteIcon'}
        class={{
          [style[`favorited-icon`]]: true,
          [style[`type-star-default`]]: true
        }}
        onClick={(event) => {
          event.stopPropagation()
          if (forbidClick) return
          this.$emit('click', this.isFavorited)
        }}
      >
        {/* 使它的实际点击区域比图标要大一点点 */}
        <div class={style['click-area']}>
          {/* 插入图案 */}
          {this.$slots.default}
        </div>
      </div>
    )
  }
}
